<div class="pt-4 pl-md-4" *ngIf="serverError !== null">
  <h2>Server Error: {{ serverError }}</h2>
</div>

<div *ngIf="(serverError === null) && !connNotFound">
  <nav class="navbar navbar-expand navbar-light bg-light capitan-sub-nav">
    <ul class="navbar-nav">
      <li class="nav-item">
        <a routerLink="/payment-processor-connections" class="nav-link arrow-link">&#8592;</a>
      </li>
    </ul>

    <ul class="navbar-nav mx-auto">
      <!-- No internal navigation (yet) for payment processor connections -->
    </ul>

    <form class="form-inline">
      <button class="btn btn-primary btn-sm ml-2"
              [class.disabled]="loadingEdit" [disabled]="loadingEdit"
              type="button" (click)="saveConn()">
        {{ loadingEdit ? 'Saving...' : 'Save' }}
      </button>
    </form>
  </nav>

  <div class="capitan-sub-nav-post-content">
    <div class="floating-alert-container">
      <div class="alert alert-success alert-dismissible" role="alert" *ngIf="successMessage">
        {{ successMessage }}
        <button type="button" class="close" (click)="successMessage = ''">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="alert alert-danger alert-dismissible" role="alert" *ngIf="errorMessage">
        {{ errorMessage }}
        <button type="button" class="close" (click)="errorMessage = ''">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="alert alert-info" role="alert" *ngIf="loadingEdit">
        Saving changes...
      </div>
    </div>

    <div class="pt-3 pl-md-4" *ngIf="serverError === null"
         style="margin-bottom: 300px;">
      <h2 class="mb-3">
        Configure Payment Processor Connection
        <span *ngIf="loadingConn" class="text-muted"> - Loading...</span>
      </h2>

      <ng-container *ngIf="!loadingConn">
        <div class="mt-3">
          <p class="mb-0">
            Connection Type: <b>{{ getPaymentProcessorTypeDisplay(conn.payment_processor) }}</b>
            <ng-container *ngIf="conn.payment_processor === PaymentProcessorType.stripe">
              <br>
              Stripe Account ID: <b>{{ conn.stripe_user_id }}</b>
            </ng-container>
            <ng-container *ngIf="conn.payment_processor === PaymentProcessorType.gravity">
              <br>
              Gravity OID: <b>{{ conn.gravity_oid }}</b>
            </ng-container>
            <ng-container *ngIf="conn.payment_processor === PaymentProcessorType.mxMerchant">
              <br>
              Merchant ID: <b>{{ conn.mx_merchant_merchant_id }}</b>
              <br>
              DBA: <b>{{ conn.mx_merchant_dba }}</b>
              <br>
              Consumer Key: <b>{{ conn.mx_merchant_consumer_api_key }}</b>
            </ng-container>
          </p>
        </div>

        <!--suppress TypeScriptValidateTypes -->
        <a *ngIf="[PaymentProcessorType.stripe, PaymentProcessorType.mxMerchant].includes(conn.payment_processor)"
           [routerLink]="'/payment-processor-connections/configure/' + conn.id.toString() + '/payment-terminals'"
           class="btn btn-primary mt-2">
          Configure Payment Terminals
        </a>

        <div *ngIf="conn.payment_processor === PaymentProcessorType.mock" class="alert alert-danger mt-2">
          This is a mock payment processor, intended for testing use only. All customer payments will automatically succeed, and no actual payments will be collected.
        </div>

        <hr>

        <form (ngSubmit)="saveConn()">
          <div class="row">
            <div class="col-lg-6 col-md-8">
              <label for="nameInput">Connection Name</label>
              <input id="nameInput" type="text" name="name"
                     class="form-control"
                     [(ngModel)]="conn.name">

              <small class="form-text text-muted">
                This name is for internal organization only, and does not impact the connection.
              </small>
            </div>
          </div>

          <ng-container *ngIf="bankAccountOptionAvailable()">
            <div class="form-group mt-3" *ngIf="conn.payment_processor === PaymentProcessorType.stripe">
              <div class="form-check">
                <input class="form-check-input" type="checkbox"
                       name="bank_account_payments_enabled"
                       id="bankAccountPaymentsEnabledInput"
                       [(ngModel)]="conn.bank_account_payments_enabled">
                <label class="form-check-label" for="bankAccountPaymentsEnabledInput">
                  Enable bank account payments
                </label>
                <div class="form-text text-danger">{{ errors.bank_account_payments_enabled }}</div>
              </div>
              <small class="form-text text-muted">
                In order to use this, bank account payments must also be enabled on your Stripe account.
                <br>
                Bank account payments are only available for recurring memberships. Bank account payments typically take 2-4 days to complete, during which the membership will be in the "payment processing" state. Memberships which have processing payments are usable for entry.
              </small>
            </div>

            <div class="form-group mt-3" *ngIf="conn.payment_processor === PaymentProcessorType.gravity">
              Bank account payments status:
              <b [class.text-danger]="!conn.bank_account_payments_enabled">
                {{ conn.bank_account_payments_enabled ? 'Enabled' : 'Disabled' }}
              </b>
              <small class="form-text text-muted">
                <ng-container *ngIf="!conn.bank_account_payments_enabled">
                  Reach out to your Gravity sales rep to set your account up to accept ACH payments.
                  <br>
                </ng-container>
                Bank account payments are only available for recurring memberships. Bank account payments typically take 2-4 days to complete, during which the membership will be in the "payment processing" state. Memberships which have processing payments are usable for entry.
              </small>
            </div>

            <div class="form-group" *ngIf="conn.bank_account_payments_enabled">
              <div class="form-check">
                <input class="form-check-input" type="checkbox"
                       name="require_bank_account_payments_for_recurring_memberships"
                       id="requireBankAccountPaymentsForRecurringMembershipsInput"
                       [(ngModel)]="conn.require_bank_account_payments_for_recurring_memberships">
                <label class="form-check-label"
                       for="requireBankAccountPaymentsForRecurringMembershipsInput">
                  Require bank account payments for recurring memberships
                </label>
                <div class="form-text text-danger">{{ errors.require_bank_account_payments_for_recurring_memberships }}</div>
              </div>
              <small class="form-text text-muted">
                This will remove the option in the Climber App to purchase a recurring membership via credit card. It will also disallow updating a recurring membership's payment method to a credit card.
              </small>
            </div>
          </ng-container>
        </form>

        <div class="form-text text-danger">{{ errors.name }}</div>
      </ng-container>
    </div>
  </div>
</div>
